import { X } from 'lucide-react';

interface ShortcutsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

interface ShortcutItem {
  keys: string[];
  description: string;
}

interface ShortcutSection {
  title: string;
  shortcuts: ShortcutItem[];
}

const shortcutSections: ShortcutSection[] = [
  {
    title: 'Move',
    shortcuts: [
      { keys: ['j'], description: 'Next article' },
      { keys: ['k'], description: 'Previous article' },
      { keys: ['Space'], description: 'Next page (Today / Recent / Fading); marks the page you left as read' },
      { keys: ['⇧', 'Space'], description: 'Previous page' },
      { keys: ['Enter'], description: 'Open article' },
      { keys: ['Esc'], description: 'Close / deselect' },
    ],
  },
  {
    title: 'Act',
    shortcuts: [
      { keys: ['l'], description: 'Like / unlike' },
      { keys: ['s'], description: 'Share' },
      { keys: ['m'], description: 'Mark as read' },
      { keys: ['⇧', 'A'], description: 'Mark everything in view as read' },
      { keys: ['r'], description: 'Refresh feeds' },
    ],
  },
  {
    title: 'Find',
    shortcuts: [
      { keys: ['/'], description: 'Search and commands' },
      { keys: ['?'], description: 'This list' },
    ],
  },
];

export default function ShortcutsModal({ isOpen, onClose }: ShortcutsModalProps) {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 backdrop-animate"
      onClick={onClose}
    >
      <div
        className="shortcuts-modal bg-canvas border border-edge modal-animate"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-label="Keyboard shortcuts"
      >
        <div className="flex items-center justify-between px-5 h-12 border-b border-edge">
          <span className="kicker text-ink">Keyboard</span>
          <button
            onClick={onClose}
            className="p-1 text-ink-muted hover:text-ink"
            aria-label="Close"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        <div className="px-5 py-4">
          {shortcutSections.map((section) => (
            <div key={section.title} className="mb-5 last:mb-0">
              <div className="kicker mb-1">{section.title}</div>
              <div>
                {section.shortcuts.map((shortcut, index) => (
                  <div key={index} className="shortcut-row">
                    <span className="shortcut-description">{shortcut.description}</span>
                    <div className="shortcut-keys">
                      {shortcut.keys.map((key, keyIndex) => (
                        <kbd key={keyIndex}>{key}</kbd>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="px-5 py-2.5 border-t border-edge">
          <p className="kicker">
            <kbd>?</kbd> opens this list anywhere
          </p>
        </div>
      </div>
    </div>
  );
}
